import { delay } from 'redux-saga';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { fromJS } from 'immutable';

import { parseJsonApi } from '../../utils/jsonapi';
import { selectConfig } from '../../export/Editor/selectors';
import { postItems } from './index';

import { UPLOAD_MEDIA_REQUESTED } from './constants';

import {
  uploadMediaItemsSucceed,
  uploadMediaItemsFailed,
} from './actions';

export function* uploadMedia({ payload }) {
  const config = yield select(selectConfig());
  const response = yield call(postItems, {
    prefix: config.get('mediaFilesPrefix'),
    upload: payload.files,
  });

  if (response.err) {
    yield put(uploadMediaItemsFailed(payload.key, response.err));
  } else {
    // При вставке аудио загружается плеер и сразу падает [18172]
    // Картинка 404 сразу после загрузки [18244]
    // @todo
    const item = fromJS(parseJsonApi(response, 'items')).first();
    const contentType = item.get('contentType');

    if (contentType.includes('image')) {
      yield call(delay, 500);
    }

    yield put(uploadMediaItemsSucceed(payload.key, response));
  }
}

export function* uploadMediaRoot() {
  yield takeLatest(UPLOAD_MEDIA_REQUESTED, uploadMedia);
}

export default uploadMediaRoot;
